<template>
    <DapMultiSelectBar v-bind="$attrs"
        class="" ref="multiSelectWithModal" :loadMore="handleLoadMore" v-on="$listeners">
        <div class="f12" slot="search-prepend" v-if="filterOption.searchList && filterOption.searchList.length">
            <el-dropdown trigger="click">
                <div class="flex-normal hand">
                    <span style="font-size: 12px;">{{ searchItem.name }}</span>
                    <el-tooltip v-show="searchItem.tip" effect="light" popper-class="dap-light-popper" placement="top-start">
                        <div slot="content" v-html="searchItem.tip" class="c-666"></div>
                        <DapIconSvg icon-class="shuoming" class="c-999 f18 hand m-l-5"/>
                    </el-tooltip>
                    <i class="m-l-5 el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="searchItem = item" v-for="item in filterOption.searchList" :key="item.key"><span style="font-size: 12px;">{{ item.name }}</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div slot="search-prefix" v-else-if="filterOption.searchTip" class="flex-center" style="height: 100%">
            <el-tooltip effect="light" popper-class="dap-light-popper" placement="top-start">
                <div slot="content" v-html="filterOption.searchTip" class="c-666"></div>
                <DapIconSvg icon-class="shuoming" class="c-999 f18 hand m-l-5"/>
            </el-tooltip>
        </div>
    </DapMultiSelectBar>
</template>
<script>
import DapMultiSelectBar from '../../../base-selector/src/MultiSelectBar';

export default {
    props: {
        filterOption: {
            type: Object,
            default: () => ({})
        },
        loadMore: {
            type: Function,
            default: () => (Promise.resolve([])),
        }
    },
    components: {
        DapMultiSelectBar,
    },
    data () {
        return {
            searchItem: null,
        }
    },
    created () {
        if ((this.filterOption.searchList || []).length) {
            this.searchItem = this.filterOption.searchList[0];
        }
    },

    methods: {
        handleLoadMore (params) {
            if (!this.filterOption.loadMore) {
                return;
            }
            // 判断searchItem
            if (this.searchItem && this.searchItem.key && this.searchItem.key !== 'search') {
                params[this.searchItem.key] = params.search;
                params.search = '';
            }
            return this.loadMore(params);
        }
    },
}
</script>
<style>

</style>
